import { defaultTheme } from 'react-admin';

export const myTheme = {
  ...defaultTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#22C55E', // সবুজ — গেমিং/বেটিং প্ল্যাটফর্মে জনপ্রিয়, চাইলে বদলাও
    },
    secondary: {
      main: '#F59E0B', // এমবার/সোনালি অ্যাক্সেন্ট
    },
    background: {
      default: '#0F172A', // গাঢ় নেভি — তোমার RewardBonus মডেলের ডিফল্ট color এর সাথেও মিলে যাচ্ছে
      paper: '#1E293B',
    },
  },
  typography: {
    fontFamily: ['Inter', 'Roboto', 'Arial', 'sans-serif'].join(','),
  },
  components: {
    ...defaultTheme.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#111827',
        },
      },
    },
    RaSidebar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0F172A',
        },
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          '&.RaMenuItemLink-active': {
            color: '#22C55E',
            borderLeft: '3px solid #22C55E',
          },
        },
      },
    },
  },
};

export const lightTheme = {
  ...defaultTheme,
  palette: {
    mode: 'light',
    primary: { main: '#16A34A' },
    secondary: { main: '#F59E0B' },
  },
};